import { createHead } from '@unhead/vue/client'
import type { Router } from 'vue-router'

export function setupAppHead(router: Router) {
    const head = createHead()

    const robotsHeadEntry = head.push({
        meta: [{ name: 'robots', content: 'index, follow' }],
    })

    router.afterEach((to) => {
        robotsHeadEntry.patch({
            meta: [
                {
                    name: 'robots',
                    content: (to.meta.robots as string | undefined) ?? 'index, follow',
                },
            ],
        })
    })

    return head
}
